import { PRO_PLAYERS } from '@/components/trial/shared/pro-players';

export const DARK_BG = '#080809';
export const NOPING_GREEN = '#93FF18';
export const EVIL_RED = '#FF3B3B';
export const ACCENT_BLUE = '#2ECDFF';
export const TEXT_LIGHT = '#E5E7EB';
export const MUTED_GRAY = '#929298';
export const CARD_DARK = '#1D2028';
export const GOLD = '#FFD700';

export const EASE_OUT = [0.25, 0.46, 0.45, 0.94] as const;
export const EASE_IN_OUT = [0.42, 0, 0.58, 1] as const;

export const NOPING_STATS = {
  users: '3M+',
  servers: '2,000+',
  countries: '150+',
  gamesSupported: '3,000+',
} as const;

export const PRO_ENDORSEMENTS = [PRO_PLAYERS.sacy, PRO_PLAYERS.brtt, PRO_PLAYERS.gaules, PRO_PLAYERS.coldzera, PRO_PLAYERS.arkane, PRO_PLAYERS.lestripez] as const;

export const POP_TOOLS = [
  { name: 'FPS Boost', popName: 'Power of the Ring', icon: '\u26A1', universe: 'LOTR' },
  { name: 'Aim Trainer', popName: 'Avada Aimvada', icon: '\uD83C\uDFAF', universe: 'Harry Potter' },
  { name: 'AudioPad', popName: 'Force Hearing', icon: '\uD83C\uDFA7', universe: 'Star Wars' },
  { name: 'Replay X', popName: 'Time-Turner', icon: '\u23EA', universe: 'Harry Potter' },
  { name: 'Pro Settings', popName: "The Oracle's Vision", icon: '\uD83D\uDCDC', universe: 'The Matrix' },
  { name: 'Multi Internet', popName: 'Shield of Gondor', icon: '\uD83D\uDEE1\uFE0F', universe: 'LOTR' },
] as const;

export const GAME_IMAGES = [
  { name: 'Valorant', file: 'Valorant.webp' },
  { name: 'CS2', file: 'CS2.webp' },
  { name: 'Fortnite', file: 'Fortnite.webp' },
  { name: 'Dota 2', file: 'Dota2.webp' },
  { name: 'World of Warcraft', file: 'World of Warcraft.webp' },
  { name: 'Final Fantasy XIV', file: 'Final Fantasy XIV.webp' },
  { name: 'Rainbow Six Siege', file: 'Rainbow Six Siege.png' },
  { name: 'Escape From Tarkov', file: 'Escape From Tarkov.webp' },
  { name: 'Ragnarok', file: 'Ragnarok.webp' },
  { name: 'Tibia', file: 'Tibia.png' },
  { name: 'StarCraft', file: 'StarCraft.webp' },
  { name: 'Albion', file: 'Albion.png' },
  { name: 'Lineage II', file: 'Lineage II.webp' },
] as const;

export const CONNECTIONS = [
  { name: 'Fiber WAN 1', type: 'fiber', basePing: 5, color: NOPING_GREEN, icon: 'M4 7h16v10H4zM8 7V4M16 7V4M12 17v3M8 11h1M12 11h1M16 11h1' },
  { name: 'Fiber WAN 2', type: 'fiber', basePing: 7, color: ACCENT_BLUE, icon: 'M4 7h16v10H4zM8 7V4M16 7V4M12 17v3M8 11h1M12 11h1M16 11h1' },
  { name: 'Fiber WAN 3', type: 'fiber', basePing: 9, color: ACCENT_BLUE, icon: 'M4 7h16v10H4zM8 7V4M16 7V4M12 17v3M8 11h1M12 11h1M16 11h1' },
  { name: '5G', type: '5g', basePing: 14, color: NOPING_GREEN, icon: 'M2 20h2M6 16h2M10 12h2M14 8h2M18 4h2' },
  { name: 'Wi-Fi', type: 'wifi', basePing: 18, color: ACCENT_BLUE, icon: 'M12 20h.01M8.5 16.5a5 5 0 017 0M5 13a10 10 0 0114 0M1.5 9.5a15 15 0 0121 0' },
  { name: 'Satellite', type: 'satellite', basePing: 35, color: ACCENT_BLUE, icon: 'M13 10V3L4 14h7v7l9-11h-7z' },
] as const;
